'use strict';
import React, { Component } from 'react';
import { GenericSimpleButton } from 'com-gyf-webcore-userinterfacecomponents';
import Titulo from './Titulo.jsx';
import DateMask from "../../../../Common/Components/Mask/DateMask.jsx"
import MontoMask from "../../../../Common/Components/Mask/MontoMask.jsx"

class Resumenes extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        const { proximoResumen, resumenAnterior } = this.props;

        return <div>
            <Titulo
                mostrarBoton={false}
                lblBoton=" Ver Anteriores"
                titulo="Próximo Resumen"
                segundoTitulo="Resumen Anterior"
            />

            <div className="row section-bordered">
                <div className="col-md-6">
                    <div className="row">
                        <div className="col-md-6">
                            <label className="label-primary">Fecha de Cierre:</label>
                        </div>
                        <div className="col-md-6">
                            <label className="label-primary"><DateMask fecha={proximoResumen && proximoResumen.FechaCierreCartera} /></label>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-6">
                            <label className="label-primary">Fecha de Vencimiento:</label>
                        </div>
                        <div className="col-md-6">
                            <label className="label-primary"><DateMask fecha={proximoResumen && proximoResumen.FechaVencimientoCartera} /></label>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-6">
                            <label className="label-primary">Forma de Pago:</label>
                        </div>
                        <div className="col-md-6">
                            <label className="label-primary">{proximoResumen && proximoResumen.FormaPago}</label>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-6">
                            <label className="label-primary">Cuenta Débito $:</label>
                        </div>

                        <div className="col-md-6">
                            <label className="label-primary">{proximoResumen && proximoResumen.CuentaBancariaNumero}</label>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-6">
                            <label className="label-primary">{/*Cuenta Débito U$S:*/}</label>
                        </div>
                        <div className="col-md-6">
                            {/*<MontoMask monto={ultimoCierre && ultimoCierre.CuentaDebitoEnPesos} moneda={"dolares"} />*/}
                            <label className="label-primary">{/*-*/}</label>
                        </div>
                    </div>
                </div>
                <div className="col-md-6">
                    <div className="row">
                        <div className="col-md-6">
                            <label className="label-primary">Fecha de Cierre:</label>
                        </div>
                        <div className="col-md-6">
                            <label className="label-primary"><DateMask fecha={resumenAnterior && resumenAnterior.FechaCierre} /></label>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-6">
                            <label className="label-primary">Fecha de Vencimiento:</label>
                        </div>
                        <div className="col-md-6">
                            <label className="label-primary"><DateMask fecha={resumenAnterior && resumenAnterior.FechaVencimiento} /></label>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-6">
                            <label className="label-primary">Saldo en $:</label>
                        </div>
                        <div className="col-md-6">
                            <MontoMask monto={resumenAnterior && resumenAnterior.SaldoCierrePesos} moneda={"pesos"} />
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-6">
                            <label className="label-primary">Saldo en U$S:</label>
                        </div>
                        <div className="col-md-6">
                            <MontoMask monto={resumenAnterior && resumenAnterior.SaldoCierreUss} moneda={"dolares"} />
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-6">
                            <label className="label-primary">Pago Mínimo</label>
                        </div>
                        <div className="col-md-6">
                            <MontoMask monto={resumenAnterior && resumenAnterior.PagoMinimo} moneda={"pesos"} />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    }
}
export default Resumenes;